import { enumType } from '@shared/core/types/common';

enum ROUNDING_TYPE {
    NO_DECIMAL = OLO.Enums.ROUNDING_TYPE.NO_DECIMAL,
    ONE_DECIMAL_PLACE = OLO.Enums.ROUNDING_TYPE.ONE_DECIMAL_PLACE,
    TWO_DECIMAL_PLACES = OLO.Enums.ROUNDING_TYPE.TWO_DECIMAL_PLACES,
}

export const roundingTypeEnum = enumType('ROUNDING_TYPE', ROUNDING_TYPE);
